module.exports = __webpack_public_path__ + "static/img/produto_p.bd38e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tonica/produto_p.png
// module id = XR9o
// module chunks = 0